function InfoSection({
  title,
  children,
  infoButton,
  action,
  className = "",
}) {
  return (
    <div
      className={`bg-white rounded-lg border border-[#61ABCF] divide-y divide-[#61ABCF] ${className}`}
    >
      <div className="grid grid-cols-2 items-center px-4 py-2">
        <dt className="flex items-center gap-1 text-sm/6 font-bold font-inter text-[#036395]">
          {title}
          {infoButton}
        </dt>

        <dd className="flex justify-end">
          {action}
        </dd>
      </div>

      {children}
    </div>
  );
}

export default InfoSection;